import { render, staticRenderFns } from "./OwnerPayoutList.vue?vue&type=template&id=3c972da8&scoped=true&lang=html&"
import script from "./OwnerPayoutList.vue?vue&type=script&lang=js&"
export * from "./OwnerPayoutList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c972da8",
  null
  
)

export default component.exports